/* src/Interviews/AvailabilityCard/styles.js */

import { grey } from '@material-ui/core/colors';

export default theme => {
  const { unit } = theme.spacing;

  return {
    paper: {
      height: unit * 102,
      overflow: 'auto',
    },
    selectWrapper: {
      display: 'flex',
      paddingTop: unit * 3,
      paddingRight: unit * 3,
      justifyContent: 'flex-end',
    },
    header: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: unit * 3,
      paddingTop: unit * 1.5,
    },
    prevNextContainer: {
      position: 'absolute',
      width: 250,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    pnExtend: {
      width: 350,
    },
    gridContainer: {
      display: 'flex',
      flex: 1,
      padding: unit * 3,
      paddingTop: 0,
    },
    grid: {
      display: 'grid',
      gridTemplate: `${unit * 3}px repeat(6, ${unit * 10}px) / repeat(7, 1fr)`,
      width: '100%',
      borderTop: '1px solid grey',
      borderLeft: '1px solid grey',
    },
    cell: {
      borderBottom: '1px solid grey',
      borderRight: '1px solid grey',
    },
    weekday: {
      display: 'flex',
      placeContent: 'center',
    },
    daysOutOfBounds: {
      backgroundColor: grey[300],
    },
    dayTextContainer: {
      borderRadius: '50%',
      gridColumn: '4 / span 2',
      gridRow: '1 / span 2',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    day: {
      display: 'grid',
      gridTemplate: 'repeat(5, 1fr) / repeat(5, 1fr)',
      gridRowGap: '1px',
      padding: 4,
    },
    availSet: {
      gridColumn: '1 / 6',
      gridRow: '3 / span 1',
      backgroundColor: theme.palette.primary.light,
      paddingLeft: unit,
    },
    hasInterview: {
      gridColumn: '1 / 6',
      gridRow: '4 / span 1',
      backgroundColor: theme.palette.secondary.light,
      paddingLeft: unit,
    },
    tinyText: {
      color: 'white',
      fontSize: 11,
      userSelect: 'none',
    },
    today: {
      backgroundColor: theme.palette.secondary.main,
    },
    whiteText: {
      color: 'white',
    },
    weekGrid: {
      display: 'grid',
      gridTemplate: `${unit * 3}px repeat(24, 20px) / repeat(7, 1fr)`,
      width: '100%',
      borderTop: '1px solid grey',
      borderLeft: '1px solid grey',
    },
    weekCell: {
      borderBottom: '1px solid grey',
      borderRight: '1px solid grey',
    },
    weekDayLabel: {

    },
    weekNone: {
      gridRow: '2 / span 24',
      backgroundColor: grey[300],
    },
    wAvail: {
      padding: 4,
    },
    weekAvailability: {
      backgroundColor: theme.palette.primary.light,
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      borderRadius: 3,
    },
    time: {
      margin: 2,
      transition: 'all .2s ease-in-out',
      height: 30,
      '&:hover': {
        transform: 'scale(1.1)',
        backgroundColor: theme.palette.primary.light,
        // border: '1px solid black',
      },
    },
    taken: {
      position: 'absolute',
      backgroundColor: theme.palette.secondary.light,
      left: 4,
      right: -3,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 4,
      borderRadius: 3,
      transition: 'all .2s ease-in-out',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    editPanel: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    editButtonContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: unit,
    },
    editTimeContainer: {
      padding: unit * 3,
    },
    editHeader: {
      margin: unit * 3,
      marginBottom: 0,
    },
    delete: {
      // left: 0,
    },
    editOptions: {
      display: 'flex',
      flexDirection: 'column',
    },
  };
};



// WEBPACK FOOTER //
// ./src/modules/interviews/cards/AvailabilityCard/styles.js